export const SOFTLINE_API_ITEM_SCAN = '/v2/items/scan/{{labelType}}/{{data}}';
